import script from "./ConferenceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ConferenceCard.vue?vue&type=script&setup=true&lang=js"

import "./ConferenceCard.vue?vue&type=style&index=0&id=72f9b6b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f9b6b8"]])

export default __exports__